/**
 * @ngdoc controllers
 * @memberof mercury.modules.stock
 * @name StockMenuPrintrecipesCtrl
 */
angular.module('mercury.modules.stock.menu')
.controller('StockMenuPrintrecipesCtrl', ["dialog", "$q", "$stateParams", "$scope", "StockRecipes", "StockMenus", "$timeout", function(dialog, $q, $stateParams, $scope, StockRecipes, StockMenus, $timeout) {
  $scope.error = false;

  window.onafterprint = function() {
    $('.print-spinner', window.parent.document).removeClass('open');
    $('.print-embed', window.parent.document).remove();
  };

  $scope.recipesLoading = StockMenus.getRecipes($stateParams.id).$promise;
  $scope.recipesLoading.then(function(recipes) {
    var imagePromises = [];
    angular.forEach(recipes, function(recipe) {
      var imagePromise = StockRecipes.getImages(recipe);

      // If an image fails to load, just ignore the error message.
      imagePromise.catch(function(response) {
        $timeout.cancel(response.defaultAlertTimeout);
      });

      imagePromises.push(imagePromise);
    });

    $scope.recipes = recipes;

    // Wait until the images finish loading before triggering the print dialog,
    // `.allSettled` used to ignore any 404 response downloading images - these
    // would otherwise immediately resolve the promise if using `.all`.
    $q.allSettled(imagePromises)
      .then(function() {
        // $timeout used to ensure Angular's digest has completed before we
        // trigger printing, without this recipe images are unreliably included
        // in the printout
        $timeout(function() {
          window.print();
        });
      });

  }, function() {
    $state.go('Stock.Menu');
  });

  $scope.totalCost = function(recipe) {
    var total = 0;
    angular.forEach(recipe.currentVersion.lines, function(line) {
      if (line.quantity) {
        total += line.currentPrice * line.quantity;
      }
    });
    return total;
  };
}]);
